module.exports = __webpack_public_path__ + "static/media/SUBMONITORCONNECT.9f4cae58.pdf";